import React from 'react'
import PropTypes from 'prop-types'
import TooltipComponent from './TooltipComponent'
import IconComponent from '../button/IconComponent'

const SearchComponent = ({ searchValue, onChange, onClick, onKeyDown }) => {
  return (
    //<TooltipComponent content="Search" id="add-tooltip" placement="top">
    <div className="search-container">
      <input
        type="text"
        className="search-input"
        placeholder="Search Here..."
        name="searchValue"
        value={searchValue}
        onChange={onChange}
        onKeyDown={onKeyDown}
        aria-label="Search Input"
      />
      <TooltipComponent content="Search" id="add-tooltip" placement="bottom">
        <button
          type="button"
          className="search-button"
          onClick={onClick}
          aria-label="Search"
        >
          <IconComponent icon="Search" /> Search
        </button>
      </TooltipComponent>
    </div>
    //</TooltipComponent>
  )
}

SearchComponent.propTypes = {
  searchValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired, // Updated from onKeyPress
}

export default SearchComponent
